import React, { useState, useEffect, useRef, useContext } from 'react';
import { RxBell } from 'react-icons/rx';
import { NotificationContext } from '../../context/NotificationContext';
import NotificationList from './NotificationList';

export default function NotificationBell() {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const { unreadCount, loadNotifications } = useContext(NotificationContext);

  useEffect(() => { loadNotifications(); }, []);
  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button onClick={() => setOpen(!open)} style={{
        position: 'relative', background: 'none', border: 'none',
        cursor: 'pointer', padding: '0.5rem', color: 'var(--gray-600)',
        display: 'flex', alignItems: 'center',
      }}>
        <RxBell size={22} />
        {unreadCount > 0 && (
          <span style={{
            position: 'absolute', top: 4, right: 4,
            width: 16, height: 16, borderRadius: '50%',
            background: 'var(--danger)', color: '#fff',
            fontSize: '0.625rem', fontWeight: 600,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </button>
      {open && <NotificationList onClose={() => setOpen(false)} />}
    </div>
  );
}